import React from "react";

import { Container } from "../../styles/GlobalStyle";

export default function App() {
  return (
    <Container isFooter>
      <p>Created by Magdalena Sułkowska</p>
    </Container>
  );
}
